<div class="popup-overlay" *ngIf="show">
  <div class="popup-content">
    <button type="button" (click)="closePopup()" [disabled]="false">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="#E9E9E9" />
        <path d="M16 16L10 10M16 10L10 16" stroke="#7A89AD" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
    <p>
      Custom Settings are now readily available <span class="emoji"><img src="../../assets/party.svg" alt="" /></span>
    </p>
    <div class="label">Unlock new possibilities with bespoke add-ons</div>
    <div class="icons">
      <button type="button" class="icon" (click)="navigateTo('/settings/account')">
        <div class="ring">
          <img alt="" src="../../assets/user.svg" />
        </div>
        <span>Users</span>
      </button>
      <button type="button" class="icon" (click)="navigateTo('/settings/pickup-locations')">
        <div class="ring">
          <img alt="" src="../../assets/location.svg" />
        </div>
        <span>Locations</span>
      </button>
      <button type="button" class="icon" (click)="navigateTo('/settings/my-drivers')">
        <div class="ring">
          <img alt="" src="../../assets/user.svg" />
        </div>
        <span>Drivers</span>
      </button>
    </div>
  </div>
</div>
